import { useEffect, useState } from "preact/hooks";

export function usePageStateMemory(
  key,
  fallbackValue,
  {
    deserialize = (storedValue) => storedValue,
    serialize = (value) => String(value ?? ""),
    removeWhen = () => false
  } = {}
) {
  const [value, setValue] = useState(() => {
    try {
      const storedValue = window.sessionStorage.getItem(key);
      if (storedValue === null) {
        return fallbackValue;
      }

      return deserialize(storedValue);
    } catch {
      return fallbackValue;
    }
  });

  useEffect(() => {
    try {
      if (removeWhen(value)) {
        window.sessionStorage.removeItem(key);
        return;
      }

      const serialized = serialize(value);
      if (serialized === null) {
        window.sessionStorage.removeItem(key);
        return;
      }

      window.sessionStorage.setItem(key, serialized);
    } catch {
      // ignore session storage failures
    }
  }, [key, removeWhen, serialize, value]);

  return [value, setValue];
}
